export default "__VITE_ASSET__BdK$OKd6__"